import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { UserFormRedirectModalComponent } from './user-form-redirect-modal.component';

@Injectable({
  providedIn: 'root',
})
export class UserFormRedirectModalService {
  constructor(private modalService: NgbModal) {}

  open(forceAddressEdit: boolean): Observable<boolean> {
    const modalRef = this.modalService.open(UserFormRedirectModalComponent, {
      beforeDismiss: () => false,
    });
    modalRef.componentInstance.forceAddressEdit = forceAddressEdit;

    return new Observable<boolean>((observer) => {
      modalRef.result
        .then(() => {
          observer.next(true);
          observer.complete();
        })
        .catch(() => {
          observer.next(false);
          observer.complete();
        });
    });
  }
}
